module.exports = __webpack_public_path__ + "img/labmemtest_text_btn01_kr.e5476045.png";